interface WindowWithIntercom extends Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Intercom?: any;
}

interface IELikeWindow extends Window {
    attachEvent(event: string, listener: EventListener): boolean;
    detachEvent(event: string, listener: EventListener): void;
}

function isIELikeWindow(w: unknown): w is IELikeWindow {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}

// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const initializeIntercomInstance = (appId: string) => {
    const w = window as WindowWithIntercom;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function () {
            i.c(arguments);
        };
        i.q = [] as Array<unknown>;
        i.c = function (args: unknown) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function () {
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x?.parentNode?.insertBefore(s, x);
        };
        if (document.readyState === "complete") {
            l();
        } else if (isIELikeWindow(w)) {
            w.attachEvent("onload", l);
        } else {
            w.addEventListener("load", l, false);
        }
    }
};

export default initializeIntercomInstance;
